<template>
  <v-btn
    block
    @click="desconectar()"
    color="error"
    height="30"
    depressed
    rounded
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
  },
  methods: {
    desconectar() {
      sessionStorage.removeItem("candidato");
      this.$router.go();
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>